import $ from 'jquery';

export default class FileUpload {
  constructor() {
    FileUpload.fileExtensionMap = {
      docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
      xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
      txt: ['text/plain'],
      png: ['image/png', 'image/x-citrix-png', 'image/x-png'],
      jpg: ['image/jpeg'],
      jpeg: ['image/jpeg'],
      webp: ['image/webp'],
      pdf: ['application/pdf'],
      gif: ['image/gif'],
    };
    FileUpload.multiple = 0;
    FileUpload.filesLimit = 0;

    FileUpload.uploadMap = {};

    this.init();
  }

  init() {
    this.isInitialized = true;
    FileUpload.attachEventListeners();
  }

  static attachEventListeners() {
    FileUpload.onUploadChangeEvent();
    FileUpload.onUploadCancelEvent();
    FileUpload.onFileRemoveEvent();
  }

  static uploadInvoke(e, file) {
    const controlRoot$ = FileUpload.getControlRoot(e);
    const template$ = controlRoot$.find('.mc-file-upload-template');

    const clone$ = template$.contents().clone();
    const id = `mc-file-upload-status-${new Date().getTime()}`;

    clone$.attr('id', id);
    clone$.appendTo(controlRoot$.find('.mc-file-input'));

    FileUpload.setError(controlRoot$, '', id);

    if (!FileUpload.fileSizeValidation(controlRoot$, e.currentTarget, file, id)) {
      FileUpload.toggleSection(controlRoot$, 'mc-file-existing', true, id);

      const fileName = FileUpload.getFileName(file.name);
      FileUpload.setFileName(controlRoot$, fileName, id);
      return;
    }

    if (!FileUpload.fileTypeValidation(controlRoot$, file, id)) {
      FileUpload.toggleSection(controlRoot$, 'mc-file-existing', true, id);

      const fileName = FileUpload.getFileName(file.name);
      FileUpload.setFileName(controlRoot$, fileName, id);

      return;
    }

    if (!FileUpload.multiple) {
      FileUpload.toggleSection(controlRoot$, 'mc-file-not-existing', false);
    }

    if (FileUpload.filesLimit <= FileUpload.checkFilesLimit(controlRoot$)) {
      FileUpload.checkFilesLimitError(controlRoot$, true);
    }

    FileUpload.toggleSection(controlRoot$, 'mc-file-inprogress', true, id);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('formId', controlRoot$.find('input.mc-file-val').attr('id'));

    const fileInput$ = $(e.currentTarget)
      .closest('.mc-file-input')
      .find(`#${id}`)
      .find('.mc-file-upload-tmp');

    const form$ = fileInput$.closest('form');
    form$.find('input[type=submit]').prop('disabled', true);

    const request = $.ajax({
      url: '/web3/api/forms/file',
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST',
      xhr() {
        const xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener(
          'progress',
          (evt) => {
            if (evt.lengthComputable) {
              const value = FileUpload.setProgressBarValue(file.size, evt.loaded);
              FileUpload.setProgressBar(controlRoot$, 'value', value, id);

              if (evt.loaded >= file.size) {
                FileUpload.setProgressBar(controlRoot$, 'finishing', null, id);
              }
            }
          },
          false,
        );
        return xhr;
      },
      success(data) {
        const fileName = FileUpload.getFileName(data);
        FileUpload.setFileName(controlRoot$, fileName, id);

        FileUpload.setFormInputValue(controlRoot$, data, id);

        fileInput$.val('');

        FileUpload.setProgressBar(controlRoot$, 'hide', null, id);
        FileUpload.toggleSection(controlRoot$, 'mc-file-inprogress', false, id);
        FileUpload.toggleSection(controlRoot$, 'mc-file-existing', true, id);

        form$.find('input[type=submit]').prop('disabled', false);
      },
      error(r, s) {
        if (s === 'error') {
            FileUpload.setProgressBar(controlRoot$, 'hide', null, id);
            FileUpload.toggleSection(controlRoot$, 'mc-file-inprogress', false, id);
            FileUpload.toggleSection(controlRoot$, 'mc-file-existing', true, id);
            FileUpload.setError(controlRoot$, r.responseText || 'Something went wront. Please try a bit later', id);
            const fileName = FileUpload.getFileName(file.name);
            FileUpload.setFileName(controlRoot$, fileName, id);
        }
      },
    });

    fileInput$.data('request', request);
  }

  static onUploadChangeEvent() {
    $(document).on('change', '.mc-file-upload', (e) => {
      const { files, multiple, dataset } = e.currentTarget;
      if (dataset && dataset.filesLimit) {
        FileUpload.filesLimit = dataset.filesLimit;
      }
      if (multiple) {
        const filesArr = [...files];
        const LimitExceededException = {};
        const controlRoot$ = FileUpload.getControlRoot(e);
        FileUpload.multiple = filesArr.length;
        try {
          filesArr.forEach((file) => {
            if (
              !FileUpload.filesLimit
              || FileUpload.filesLimit > FileUpload.checkFilesLimit(controlRoot$)
            ) {
              FileUpload.uploadInvoke(e, file);
            } else {
              throw LimitExceededException;
            }
          });
        } catch (error) {
          if (error === LimitExceededException) {
            FileUpload.checkFilesLimitError(controlRoot$, true);
          }
        }
      } else {
        FileUpload.uploadInvoke(e, files[0]);
      }
    });
  }

  static onUploadCancelEvent() {
    $(document).on('click', '.mc-file-upload-cancel', (e) => {
      e.preventDefault();

      const controlRoot$ = FileUpload.getControlRoot(e);
      const form$ = controlRoot$.closest('form');
      const id = $(e.currentTarget).closest('[id^=mc-file-upload-status-]').attr('id');
      const fileInput$ = $(e.currentTarget)
        .closest('.mc-file-input')
        .find(`#${id}`)
        .find('.mc-file-upload-tmp');

      fileInput$.data('request').abort();

      FileUpload.updateFormInputValue(controlRoot$, id);

      FileUpload.setProgressBar(controlRoot$, 'hide', id);
      FileUpload.toggleSection(controlRoot$, 'mc-file-inprogress', false, id);
      FileUpload.toggleSection(controlRoot$, 'mc-file-not-existing', true, id);
      FileUpload.checkFilesLimitError(controlRoot$, false);

      controlRoot$.find(`#${id}`).remove();
      form$.find('input[type=submit]').prop('disabled', false);
    });
  }

  static onFileRemoveEvent() {
    $(document).on('click', '.mc-file-existing-remove', (e) => {
      e.preventDefault();

      const controlRoot$ = FileUpload.getControlRoot(e);
      const id = $(e.currentTarget).closest('[id^=mc-file-upload-status-]').attr('id');

      FileUpload.updateFormInputValue(controlRoot$, id);

      FileUpload.toggleSection(controlRoot$, 'mc-file-existing', false, id);
      FileUpload.toggleSection(controlRoot$, 'mc-file-not-existing', true, id);
      FileUpload.checkFilesLimitError(controlRoot$, false);

      controlRoot$.find(`#${id}`).remove();
    });
  }

  static toggleSection(controlRoot$, selector, visible, id) {
    const section$ = controlRoot$.find(`#${id}`).find(`.${selector}`);
    if (visible) {
      section$.removeClass(`${selector}--hidden`);
    } else {
      section$.addClass(`${selector}--hidden`);
    }
  }

  static toggleDisable(controlRoot$, selector, disable) {
    const section$ = controlRoot$.find(`.${selector}`);
    if (disable) {
      section$.addClass(`${selector}--disable`);
    } else {
      section$.removeClass(`${selector}--disable`);
    }
  }

  static setProgressBar(controlRoot$, action, value, id) {
    const progressValue$ = controlRoot$.find(`#${id}`).find('.progress-value');
    switch (action) {
      case 'value':
        progressValue$.css('width', `${value < 100 ? value : 100}%`);
        break;
      case 'finishing':
        progressValue$.addClass('progress-striped active');
        break;
      default:
        progressValue$.css('width', '0%').removeClass('progress-striped active');
        break; // 'hide'
    }
  }

  static setProgressBarValue(maxFileSize, loadedFileSize) {
    return Math.round((loadedFileSize / maxFileSize) * 100);
  }

  static getControlRoot(event) {
    const target$ = $(event.currentTarget);
    return target$.closest('.mc-form-fieldtype');
  }

  static fileSizeValidation(controlRoot$, eventTarget, file, id) {
    const maxFileSize = parseInt(controlRoot$.data('max-file-size'), 10);
    const maxFileSizeError = controlRoot$.data('max-file-size-error');

    if (file.size > maxFileSize) {
      FileUpload.updateFormInputValue(controlRoot$, id);
      FileUpload.setError(controlRoot$, maxFileSizeError, id);
      return false;
    }
    return true;
  }

  static fileTypeValidation(controlRoot$, file, id) {
    const fileUpload$ = controlRoot$.find('.mc-file-upload');
    let acceptString = fileUpload$.attr('accept');
    if (acceptString) {
      acceptString = acceptString.replace(/\./g, '');
    } else {
      return true;
    }

    const accept = acceptString.split(',').map((s) => s.trim());
    if (accept.includes('jpg')) {
      accept.push('jpeg');
    }

    const mimeTypes = accept.filter((s) => /\//.test(s));
    const fileExts = accept.filter((s) => !/\//.test(s));

    if (mimeTypes.length) {
      if (mimeTypes.includes(file.type)) {
        return true;
      }
      const wildCardTypes = mimeTypes.filter((t) => /\*/.test(t));
      if (wildCardTypes.length) {
        const valid = wildCardTypes.some((w) => {
          const cat = w.split('/')[0];
          return new RegExp(`${cat}/.+`, 'gi').test(file.type);
        });
        if (valid) {
          return true;
        }
      }
    }

    if (fileExts.length) {
      const fileParts = file.name.split('.');
      const fileExt = fileParts[fileParts.length - 1].toLowerCase();
      const isFileExtAllowed = fileExts.includes(fileExt);

      if (isFileExtAllowed) {
        return true;
      }
    }

    const fileTypeError = controlRoot$.data('max-file-type-error');
    FileUpload.setError(controlRoot$, `${fileTypeError} <b>${accept.sort().join(', ')}</b>`, id);
    return false;
  }

  static setError(controlRoot$, message, id) {
    const name = controlRoot$.find('input.mc-file-val').attr('id');
    if (message) {
      const spanClone$ = controlRoot$.parent().find('> [class^=field-validation]').clone();
      spanClone$.appendTo(controlRoot$.find(`#${id}`));
    }

    const span = controlRoot$.find(`#${id}`).find(`span[data-valmsg-for='${name}']`);
    FileUpload.toggleError(span, message, name);
  }

  static toggleError(span, message, name) {
    if (span && span.length > 0) {
      $(span).html(message);
      if (message) {
        $(`input[name='${name}']`).addClass('input-validation-error');
        $(span).removeClass('field-validation-valid');
        $(span).addClass('field-validation-error');
      } else {
        $(`input[name='${name}']`).removeClass('input-validation-error');
        $(span).removeClass('field-validation-error');
        $(span).addClass('field-validation-valid');
      }
    }
  }

  static getFileName(data) {
    const urlParts = decodeURIComponent(data).split('/');
    return urlParts[urlParts.length - 1];
  }

  static setFileName(controlRoot$, fileName, id) {
    const existingName$ = controlRoot$.find(`#${id}`).find('.mc-file-existing-name');
    existingName$.text(fileName);
    existingName$.attr('title', fileName);
  }

  static setFormInputValue(controlRoot$, data, id) {
    const formInput$ = controlRoot$.find('input.mc-file-val');
    const setData = formInput$.val();
    const valArr = setData.length ? setData.split(', ') : [];
    valArr.push(data);
    formInput$.val(valArr.join(', '));
    FileUpload.uploadMap[id] = data;
  }

  static updateFormInputValue(controlRoot$, id) {
    const fileName = FileUpload.uploadMap[id];
    const formInput$ = controlRoot$.find('input.mc-file-val');
    const setData = formInput$.val();
    if (fileName && setData.length) {
      const valArr = setData.split(', ');
      const index = valArr.indexOf(fileName);
      valArr.splice(index, 1);
      formInput$.val(valArr.join(', '));
      delete FileUpload.uploadMap[id];
    }
  }

  static checkFilesLimit(controlRoot$) {
    return controlRoot$.find('[id^=mc-file-upload-status-]').length;
  }

  static checkFilesLimitError(controlRoot$, show) {
    FileUpload.toggleDisable(controlRoot$, 'mc-file-not-existing', show);
    if (!FileUpload.multiple) {
      return;
    }

    const message = show ? 'file limit exceeded' : '';
    const name = controlRoot$.find('input.mc-file-val').attr('id');

    if (!message) {
      controlRoot$.find('.mc-file-input').find('.field-validation-error').remove();
      return;
    }

    if (!controlRoot$.find('.mc-file-input').find('.field-validation-error').length) {
      const spanClone$ = controlRoot$.parent().find('> [class^=field-validation]').clone();
      spanClone$.appendTo(controlRoot$.find('.mc-file-input'));
    }

    const span = controlRoot$.find(`span[data-valmsg-for='${name}']`);
    FileUpload.toggleError(span, message, name);
  }
}
